var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"successShared"},[_c('Ok'),_c('span',{staticClass:"linkCopied"},[_vm._v(_vm._s(_vm.$t('link_copied')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }